<template>
    <div class="discovermode-button-component-wrapper">

        <button v-if="!href || disabled"
                :id="id"
                type="button"
                :class="buttonClasses"
                :disabled="disabled"
                :aria-describedby="ariaDescribedBy || undefined"
                @click="$emit('click')">
            <span v-if="!animated" class="static-label">{{ text }}</span>
            <div class="motion-track-slides" v-if="animated">
                <span class="motion-track-slide-main">{{ text }}</span>
                <span class="motion-track-slide-pseudo" aria-hidden="true">{{ text }}</span>
            </div> 
        </button>

        <a v-else
           :id="id"
           :href="href"
           :class="buttonClasses">
            <span v-if="!animated" class="static-label">{{ text }}</span>
            <div class="motion-track-slides" v-if="animated">
                <span class="motion-track-slide-main">{{ text }}</span>
                <span class="motion-track-slide-pseudo" aria-hidden="true">{{ text }}</span>
            </div>
        </a>

    </div>
</template>

<script>
    export default {
        name: 'ButtonDiscoverMode',
        props: {
            text: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: ''
            },
            href: {
                type: String,
                default: ''
            },
            fullwidth: {
                type: Boolean,
                default: false
            },
            animated: {
                type: Boolean,
                default: true
            },
            variant: {
                type: String,
                default: 'filled'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            ariaDescribedBy: {
                type: String,
                default: ''
            }
        },
        computed: {
            buttonClasses() {
                return [
                    'button-component',
                    this.variant,
                    {
                        'fullwidth': this.fullwidth
                    }
                ];
            }
        }
    }
</script>